// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import styles from "assets/jss/style-component/components/cardStyle.js";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import React from "react";
import {useTheme} from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function Card(props) {
  const { className, children, plain, profile, info, chart, ...rest } = props;
  const cardClasses = estilos(useStyles(), props, "card");
  const theme = useTheme();
  const style = {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  };

  return (
    <div className={cardClasses} {...rest} style={style}>
      {children}
    </div>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node
};
